import {makeGetProvidersMedicalGuide} from 'main/factories/usecases';
import {ProvidersMedicalGuide} from 'domain/usecases';
import {HealthProvidersParams} from './types';

async function getHealthProviders(params: HealthProvidersParams): Promise<ProvidersMedicalGuide[]> {
	const {
		cdUf,
		nmCidade,
		coordenadas,
		dsTipo,
		dsEspecialidade,
		cd_procedimento,
		tpRede,
		distancia,
		signal,
	} = params;

	const response = await makeGetProvidersMedicalGuide().get({
		...(coordenadas === undefined && {cdUf}),
		...(coordenadas === undefined && {nmCidade}),
		...(coordenadas !== undefined && {coordenadas}),
		dsTipo,
		dsEspecialidade: dsEspecialidade || '',
		cd_procedimento: cd_procedimento || '',
		retornoAgrupado: true,
		...(tpRede !== undefined && {tpRede}),
		signal,
		distancia: distancia || '25',
	});

	const hasGroupedResponse =
		response.telemedicina || response.redePropria || response.redeCredenciada;

	if (hasGroupedResponse) {
		const telemedicina = response.telemedicina || [];
		const redePropria = response.redePropria || [];
		const redeCredenciada = response.redeCredenciada || [];

		if (telemedicina.length === 0 && redePropria.length === 0 && redeCredenciada.length === 0) {
			return [];
		}

		return [...telemedicina, ...redePropria, ...redeCredenciada];
	}

	if (Array.isArray(response.prestadores)) {
		if (response.prestadores.length === 0) {
			return [];
		}
		return response.prestadores;
	}

	throw new Error('Formato de resposta inválido');
}

export {getHealthProviders};
